/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum EDashboardSuiviMode {
    ARealiser = 'ARealiser',
    Demande = 'Demande',
    ASuivre = 'ASuivre'
}


export function EDashboardSuiviModeFromJSON(json: any): EDashboardSuiviMode {
    return EDashboardSuiviModeFromJSONTyped(json, false);
}

export function EDashboardSuiviModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EDashboardSuiviMode {
    return json as EDashboardSuiviMode;
}

export function EDashboardSuiviModeToJSON(value?: EDashboardSuiviMode | null): any {
    return value as any;
}

